(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["studio-sur-watermarks"] && !Shopify.designMode) return;
  try {
    class SurPreviewWatermarks extends HTMLElement {
  connectedCallback() {
    this.images = new Map();
    this.queue = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    };
    this.resizeObserver = new ResizeObserver(this.queue);
    this.mutationObserver = new MutationObserver(this.queue);
    this.mutationObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', this.queue);
    this.queue();
  }

  update() {
    for (const [image, entry] of this.images) {
      if (image.isConnected && entry.mark.isConnected) continue;
      entry.mark.remove();
      this.resizeObserver.unobserve(image);
      image.removeEventListener('load', this.queue);
      this.images.delete(image);
    }
    document.querySelectorAll('img').forEach(image => {
      if (this.images.has(image)) return;
      if (!/studio-sur-(afterglow|bete|fern|nara)-\d+-preview/i.test(image.currentSrc || image.src)) return;
      const parent = image.parentElement.tagName === 'PICTURE' ? image.parentElement.parentElement : image.parentElement;
      if (!parent) return;
      if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
      const mark = document.createElement('span');
      mark.className = 'sur-preview-watermark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = this.dataset.label;
      parent.append(mark);
      this.images.set(image, { mark, parent });
      this.resizeObserver.observe(image);
      image.addEventListener('load', this.queue);
    });
    for (const [image, { mark, parent }] of this.images) {
      const box = image.getBoundingClientRect();
      const parentBox = parent.getBoundingClientRect();
      if (!image.complete || !image.naturalWidth || box.width === 0 || box.height === 0) {
        mark.hidden = true;
        continue;
      }
      mark.hidden = false;
      let width = box.width;
      let height = box.height;
      const style = getComputedStyle(image);
      if (style.objectFit === 'contain' || style.objectFit === 'scale-down') {
        let scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        if (style.objectFit === 'scale-down') scale = Math.min(1, scale);
        width = image.naturalWidth * scale;
        height = image.naturalHeight * scale;
      }
      const inset = Math.max(5, Math.min(16, width * .035));
      mark.style.right = Math.max(0, parentBox.right - box.right + (box.width - width) / 2 + inset) + 'px';
      mark.style.bottom = Math.max(0, parentBox.bottom - box.bottom + (box.height - height) / 2 + inset) + 'px';
      mark.style.fontSize = Math.max(6, Math.min(14, width * .03)) + 'px';
    }
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.mutationObserver?.disconnect();
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.queue);
    for (const [image, { mark }] of this.images) {
      image.removeEventListener('load', this.queue);
      mark.remove();
    }
  }
}
if (!customElements.get('sur-preview-watermarks')) customElements.define('sur-preview-watermarks', SurPreviewWatermarks);
  } catch(e) { console.error(e); }
})();

})();
